<template>
  <b-card
    v-if="data"
    body-class="pb-50"
  >
    <h6>Hasil Sidang Berdasarkan Status</h6>
    <!-- chart -->
    <vue-apex-charts
      height="300"
      :options="data.chartOptions"
      :series="data.series"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

const $barColor = '#f3f3f3'

export default {
  components: {
    BCard,
    VueApexCharts,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    }
  },
}
</script>
